










































































































import BaseComponent from '@/components/base-component.vue';
import ContactFilters from '@/components/crm/contact/contact-filters.vue';
import ContactForm from '@/components/crm/contact/contact-form.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiTableContainer from '@/components/UI/table-container.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { PaginationSyncDTO, ResultPagDTO } from '@/interfaces/base-dto';
import { ContatoFiltrosParmDTO } from '@/interfaces/crm-contact';
import * as service from '@/services/crm-contact';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    ContactForm,
    UiFilterContainer,
    UiTableContainer,
    UiToggleStatus,
    ContactFilters
  }
})
export default class Contact extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public edit: boolean = false;

  idSelected = null;
  filter: any = {};

  items = [];
  pagination: PaginationSyncDTO = new PaginationSyncDTO();
  pagina: ResultPagDTO<any> = new ResultPagDTO();
  loading = false;
  error = false;

  public headers: any = [
    { text: 'Nome', value: 'nome', sortable: true },
    { text: 'Celular ou Telefone', value: 'celular, telefone', sortable: false },
    { text: 'Email', value: 'email', sortable: false },
    { text: 'Instituições', value: 'qtdeInstituicoes', sortable: false },
    { text: 'Alterado por', value: 'loginAlteracao', sortable: true },
    { text: 'Alterado em', value: 'dataAlteracao', sortable: true },
    { text: '', value: '', sortable: false, width: '30' }
  ];

  mounted() {
    this.load();
  }

  newItem() {
    this.idSelected = null;
    this.formOpen = true;
    this.edit = true;
  }

  openItem(item, edit) {
    this.idSelected = item.id;
    this.formOpen = true;
    this.edit = edit;
  }

  onCloseForm() {
    this.formOpen = false;
  }

  onAfterSave() {
    this.formOpen = false;
    this.load();
  }

  public onFilter(value): void {
    this.filter = value;
    this.pagination.page = 1;
    if (this.filter.sortBy) {
      this.pagination.descending = this.filter.descending;
      this.pagination.sortBy = this.filter.sortBy;
    }
    this.load();
  }

  onChangeFilter() {
    this.load();
  }

  load() {
    this.items = [];
    this.loading = true;

    let filters = new ContatoFiltrosParmDTO();
    filters.textoBusca = this.filter.textoBusca;
    filters.update(this.pagination);
    service.listCrmContactsByFilters(filters).subscribe(
      (result) => {
        this.items = result.content;
        this.loading = false;
        this.pagina = result;
        PaginationSyncDTO.update(this.pagination, result);
      },
      (error) => {
        this.loading = false;
        this.showToastApiError(error);
      }
    );
  }

  onItemActivationChange(item, status) {
    this.loader.start('Processando ...');
    service.updateActivationCrmContact(item.id, status).subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show(`Contato ${status ? 'ativado' : 'desativado'} com sucesso`, 'success');
        this.load();
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }

  @Watch('pagination')
  private onChangePagination() {
    this.load();
  }
}
